






















import { BillItem, BillItemGroup } from '@/models/billData';
import { Component, Vue } from 'vue-property-decorator';
import BillItemTable from '@/components/bill/billItemTable.vue';
import { BillItemGroupTypes, getBillItemGroupTypes, getBillItemGroupTypeName } from '@/enums/billItemGroupTypes';
import { KeyValuePair } from '@/models/keyValuePair';
import Axios from 'axios';
import { BillItemsResponse } from '@/models/billItemResponse';
import { BillItemsRequest } from '@/models/billItemRequest';
import AvaivaledVue from '@/components/avaivaled.vue';
import { FunctionTypes } from '@/enums/functionTypes';

@Component({
  components: {
    BillItemTable,
  }
})
export default class BillItemsSettings extends AvaivaledVue {
  public getBillItemGroupTypeName = getBillItemGroupTypeName;

  public activeName: string = BillItemGroupTypes.MembershipFee.toString();

  public billItemGroups: BillItemGroup[] = [];

  get localBillGroupItems(): Array<KeyValuePair<BillItemGroupTypes, BillItem[]>> {
    return this.billItemGroups.reduce((list, item) => {
      const group = list.find((value) => value.key === item.groupType);
      if (group) {
        group.value.push(...item.billItems);
      } else {
        list.push({
          key: item.groupType,
          value: item.billItems,
        });
      }
      return list;
    }, new Array<KeyValuePair<BillItemGroupTypes, BillItem[]>>());
  }

  public async created() {
    const ok = await this.pageBackCheck(FunctionTypes.Bill);
    if (!ok) {
      return;
    }

    await this.loadData();
  }

  private deactivated() {
    this.$destroy();
  }

  private async loadData() {
    try {
      const res = await Axios.get<BillItemsResponse>('/api/bill-items');
      const resData = res.data;

      this.billItemGroups = resData.billItemGroups.map((group) => ({
        groupType: group.billItemGroupType,
        billItems: group.billItems.map((item) => ({
          itemId: item.billItemId,
          itemName: item.itemName,
          nonTaxable: item.nonTaxable,
          gradeYearItems: item.gradeYears.map((gradeYear) => ({
            gradeYear: gradeYear.gradeYear,
            unitPrice: gradeYear.unitPrice,
          })),
        }))
      }));
    } catch (error) {
      //
    }
  }

  private async onRegister(groupType: BillItemGroupTypes, items: BillItem[]) {
    try {
      const req: BillItemsRequest = {
        groupType,
        billItems: items.map((item) => ({
          billItemId: item.itemId,
          itemName: item.itemName,
          nonTaxable: item.nonTaxable,
          gradeYears: item.gradeYearItems.map((gradeYear) => ({
            gradeYear: gradeYear.gradeYear,
            unitPrice: gradeYear.unitPrice,
          }))
        }))
      };
      await Axios.put('/api/bill-items', req);
      this.$notify.success({
        title: '更新完了',
        message: '請求項目を更新しました。',
        position: 'bottom-right'
      });
    } catch (error) {
      this.$notify.error({
        title: '請求項目更新エラー',
        message:
          (error.response && error.response.data) || '請求項目の更新が失敗しました。',
        position: 'bottom-right'
      });
      return;
    }

    const group = this.billItemGroups.find((item) => item.groupType === groupType);
    if (group) {
      group.billItems = items;
    } else {
      this.billItemGroups.push({
        groupType,
        billItems: items,
      });
    }
  }
}
